/**
 * Pure helpers for filing logic shared across components.
 */

/**
 * Gate for the Reopen affordance on task-source filings.
 * Only `status === 'filed'` is reopenable; client_notified and cancelled stay locked
 * (mirrors task-detail page behaviour — filed→in_progress via the reopen endpoint).
 */
export function canReopen(status: string): boolean {
  return status === 'filed';
}
